/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import HolidayListing from './Listing';
import { getQueryStr, isAgentLoggedIn } from '../../common/utils/browserUtils';
import { getAllUrlParams } from '../helpers/utils';
import { getAffiliateDetails } from '../../common/utils/appUtils';
import { LISTING_BASE_PATH } from '../../common/constants/appConstant';
import { CLOSE_COACHMARK_CLICKED } from '../../common/constants/coachmarkConstant';
import '../../common/font-icons/style.css';

const App = () => {
  useEffect(() => {
    if (isAgentLoggedIn() && !MMT_HLD?.HolidayShowListingV3Agent) {
      const urlParams = getAllUrlParams() || {};
      urlParams.version = 2;
      const url = `${getAffiliateDetails()?.baseUrl}${LISTING_BASE_PATH}?${getQueryStr(urlParams)}`;
      window.location.replace(url);
    }
    if (MMT_HLD.isMobile === undefined) {
      const isMobileDevice = window.screen.availWidth < 767;
      MMT_HLD.isMobile = isMobileDevice;
    }
    window?.localStorage?.setItem(CLOSE_COACHMARK_CLICKED, 'true');
  }, []);

  return (
    <Routes>
      <Route path="/*" element={<HolidayListing />} />
    </Routes>
  );
};

export default App;
